import React, { Component } from 'react';
import {
  Button,
} from 'react-bootstrap';
// icons
import Icon from 'react-icons/lib/go/pencil';
// stores
import PropertyStore from '../../stores/PropertyStore';
// components
import PropertyDialog, { PropertyFormType } from '../../components/Property/PropertyDialog';
// model
import Property from '../../models/Property';
// css
import './Buttons.css';

class AddPropertyButton extends Component {
  constructor(props) {
    super(props);
    this.state = { showDialog: false };
  }

  render() {
    const { property } = this.props;

    return (
      <Button bsStyle="primary" onClick={() => this.showDialog(true)}>
        <div className="Buttons-container">
          <div className="Buttons-icon"><Icon /></div>
          <div className="Buttons-text">Info</div>
        </div>
        <PropertyDialog
          show={this.state.showDialog}
          formType={PropertyFormType.Edit}
          property={new Property(property)}
          onSave={this.onSave}
          onCancel={() => this.showDialog(false)} />
      </Button>
    );
  }

  showDialog = (bShow = false) => {
    this.setState({ showDialog: bShow });
  }

  onSave = (property) => {
    if (property) {
      PropertyStore.update(property);
      this.showDialog(false);
    }
  }
}

export default AddPropertyButton;


// WEBPACK FOOTER //
// ./src/components/Buttons/EditProperty.js